import numeral from 'numeral';
import i18next, { InitOptions } from 'i18next';

import en from '../configs/locales/en.json';
import es from '../configs/locales/es.json';

import 'numeral/locales/es';

const fallbackLng = 'en';

export type Language = 'en' | 'es';

const supportedLngs: Language[] = ['en', 'es'];

export const LANGUAGE_TO_LANGUAGE_WITH_COUNTRY_MAP = new Map<Language, string>([
  ['en', 'en-US'],
  ['es', 'es-US'],
]);

const options: InitOptions = {
  fallbackLng,
  supportedLngs,
  resources: {
    en,
    es,
  },
  detection: {
    order: ['path'],
  },
  saveMissing: process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test',
  missingKeyHandler(lngs, _ns, key) {
    throw new Error(`Missing localization for key ${key} for lang ${lngs}`);
  },
  interpolation: {
    format(value, format, lng): string {
      if (!format) {
        return value;
      }

      const [, formatter, option] = /(.+):(.+)/.exec(format) as Array<string>;

      numeral.locale(lng);

      if (formatter === 'number') return numeral(value).format(option);
      return value;
    },
  },
};

const instance = i18next.createInstance();

instance.init(options);

export default instance;
